<script>
  import { createEventDispatcher } from "svelte";
  import { LinearDisplayFormat } from "dimtext";
  import DimtextInputBare from "./DimtextInputBare.svelte";
  import modifyDimString from "@local/extensions/utilities/modify-dim-string.js";

  import dimSettings from "@local/extensions/utilities/dim-settings.js";

  export let border = false;
  export let label = "Label";
  /** @type {string | null} */
  export let labelWidth = null;
  export let values;
  export let disabled = false;
  export let readonly = false;
  export let validator = (v) => true;
  export let coercer = (v) => v;
  export let settings;
  export let allowNull = false;
  export let max = undefined;
  export let min = undefined;
  export let reversed = false;
  export let preserveOverallLength = false;

  const dispatch = createEventDispatcher();

  let input;
  let focused = false;
  let showCalculator = false;

  $: ds = dimSettings(settings);
  $: lw = labelWidth ? `width:${labelWidth};` : "";
  $: displayValues = values.map((v) => formatDisplayValue(v.value, ds));

  function formatDisplayValue(value, ds) {
    try {
      const v = value?.format(LinearDisplayFormat[ds.dimFormat], ds.dimPrecision, {
        displayUnit: ds.displayUnit,
        showUnit: true,
        unitSymbols: "ascii",
      });
      if (v) return v;
    } catch (e) {
      return null;
    }
    return null;
  }

  function updateValue(evt, i) {
    const { value } = evt.detail;
    const index = reversed ? values.length - 1 - i : i;
    const newValues = values.slice();
    if (preserveOverallLength) {
      modifyDimString(newValues, index, value, ds.displayUnit);
    } else {
      newValues[index] = { ...newValues[index], value };
    }
    dispatch("input", { value: newValues });
  }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="prop-container relative"
  class:focused
  class:showCalculator
  class:readonly={disabled || readonly}
  class:visible-border={border}
  on:mouseover
  on:mouseout
  on:focus
  on:blur>
  <div class="label py-0.5" style={lw}>
    <slot name="label">
      {label}
    </slot>
  </div>
  {#if readonly}
    {#each displayValues as displayValue}
      <div bind:this={input} class="input">{displayValue}</div>
    {/each}
  {:else}
    <div class="grow">
      {#each reversed ? values.toReversed() : values as value, i}
        <DimtextInputBare
          value={value.value}
          {disabled}
          {validator}
          {coercer}
          {settings}
          {allowNull}
          {max}
          {min}
          on:input={(e) => updateValue(e, i)} />
      {/each}
    </div>
  {/if}
</div>

<style lang="scss">
  input.input {
    border: none;
    background-color: none;
    outline: none;
    min-width: 0;
    max-width: 100%;
  }

  .prop-container {
    @apply px-2 py-2 w-full flex items-start rounded;

    .label {
      @apply truncate text-gray-400 flex-none;
    }

    .calculator-button {
      @apply hidden right-0;
    }

    &:hover .calculator-button,
    &.focused .calculator-button,
    &.showCalculator .calculator-button {
      @apply block;
    }

    &:hover:not(.readonly),
    &.visible-border {
      @apply ring-1 ring-inset ring-gray-300;
    }

    &.focused {
      @apply ring-2 ring-inset ring-blue-500;
    }

    .input {
      @apply min-w-0 grow shrink bg-transparent ml-2;
    }
  }
</style>
